import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-image-full-page-with-video.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var BannerHeroImageFullPageWithVideo = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroImageFullPageWithVideo, _super);
    function BannerHeroImageFullPageWithVideo(element) {
        return _super.call(this, element) || this;
    }
    BannerHeroImageFullPageWithVideo.prototype.init = function () {
        var _this = this;
        this.buttonMute = this.element.querySelector('.banner-hero-image-full-page-with-video__mute');
        this.video = this.element.querySelector('.js-video-trigger');
        if (this.element.querySelector('.banner-hero-image-full-page-with-video__mute--icon')) {
            this.muteIcon = this.element.querySelector('.banner-hero-image-full-page-with-video__mute--icon');
            this.muteText = this.element.querySelector('.banner-hero-image-full-page-with-video__mute--text');
            this.muteTextFunction(this.muteText);
            var muteTextFunction_1 = this.muteTextFunction;
            var muteText_1 = this.muteText;
            window.addEventListener('resize', function (event) {
                muteTextFunction_1(muteText_1);
            });
        }
        this.bigSliderContainer = this.element.querySelector('.banner-hero-image-full-page-with-video__banner--swiper');
        this.bigSliderPagination = this.element.querySelector('.swiper-pagination');
        this.bigSlider = new Swiper(this.bigSliderContainer, {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 0,
            autoplay: {
                delay: 30000,
                disableOnInteraction: false,
            },
            pagination: {
                el: this.bigSliderPagination,
                type: 'bullets',
                clickable: true
            },
        });
        this.bigSlider.on('slideChange', function (event) {
            _this.pauseAllVideos();
            _this.playActiveSlideVideo();
        });
        this.bigSlider.on('slideChangeTransitionEnd', function (event) {
            _this.detectHasVideo();
        });
        this.smallSliderContainer = this.element.querySelector('.banner-hero-image-full-page-with-video__carousel--swiper');
        this.smallSlider = new Swiper(this.smallSliderContainer, {
            slidesPerView: 1.2,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1201: {
                    initialSlide: 0,
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1025: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                581: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                481: {
                    initialSlide: 0,
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            navigation: {
                nextEl: '.banner-hero-image-full-page-with-video__carousel--container__rightarrow',
                prevEl: '.banner-hero-image-full-page-with-video__carousel--container__leftarrow',
            }
        });
        // this.carouselContainer = this.element.querySelector('.banner-hero-image-full-page-with-video__carousel--swiper');
        // this.items = Array.from(this.element.querySelectorAll('.swiper-slide'));
        // if(this.items.length === 3) {
        // 	this.swiperContainer.classList.add('three-items');
        // } else if(this.items.length === 2) {
        // 	this.swiperContainer.classList.add('two-items');
        // } else if(this.items.length === 1) {
        // 	this.swiperContainer.classList.add('one-item');
        // }
        // this.createCarouselPageLoad();
        // window.addEventListener('resize', () => {
        // 	this.createCarouselResize();
        // })
        this.pauseAllVideos();
        this.playActiveSlideVideo();
        this.detectHasVideo();
        this.detectBizConnect();
    };
    BannerHeroImageFullPageWithVideo.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonMute) {
            this.buttonMute.addEventListener('click', function (e) {
                _this.toggleMute();
            });
        }
    };
    BannerHeroImageFullPageWithVideo.prototype.pauseAllVideos = function () {
        var videos = Array.from(this.element.querySelectorAll('video'));
        videos.forEach(function (video) {
            video.playsInline = true;
            video.muted = true;
            video.currentTime = 0;
        });
    };
    BannerHeroImageFullPageWithVideo.prototype.createCarouselPageLoad = function () {
        if (this.swiperContainer.classList.contains('three-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false,
                navigation: {
                    nextEl: '.banner-hero-image-full-page-with-video__carousel--container__rightarrow',
                    prevEl: '.banner-hero-image-full-page-with-video__carousel--container__leftarrow',
                }
            });
        }
        // let generateBreakpoints: any = this.generateBreakpoints();
        // this.carousel = new Swiper(this.carouselContainer, {
        // 	slidesPerView: generateBreakpoints.slidesPerView,
        // 	centeredSlides: false,
        // 	spaceBetween: 30,
        // 	initialSlide: 0,
        // 	breakpoints: generateBreakpoints.breakpoints,
        // 	freeMode: false
        // });
    };
    BannerHeroImageFullPageWithVideo.prototype.createCarouselResize = function () {
        this.carousel.destroy();
        if (this.swiperContainer.classList.contains('three-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false
            });
        }
        else {
            this.carousel = new Swiper(this.carouselContainer, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 1.3,
                        spaceBetween: 30,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                },
                freeMode: false,
                navigation: {
                    nextEl: '.banner-hero-image-full-page-with-video__carousel--container__rightarrow',
                    prevEl: '.banner-hero-image-full-page-with-video__carousel--container__leftarrow',
                }
            });
        }
        // let generateBreakpoints: any = this.generateBreakpoints();
        // this.carousel = new Swiper(this.carouselContainer, {
        // 	slidesPerView: generateBreakpoints.slidesPerView,
        // 	centeredSlides: false,
        // 	spaceBetween: 30,
        // 	initialSlide: 0,
        // 	breakpoints: generateBreakpoints.breakpoints,
        // 	freeMode: false
        // });
    };
    BannerHeroImageFullPageWithVideo.prototype.generateBreakpoints = function () {
        var slidesPerView = 0;
        var breakpoints = {};
        // if there are only 3 slides captured
        if (this.swiperContainer.classList.contains('three-items')) {
            slidesPerView = 3;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
            // if there are only 2 slides captured
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            slidesPerView = 2;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
            // if there are only 1 slide captured
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            slidesPerView = 1;
            // if there are is more than 3 items
        }
        else {
            slidesPerView = 3;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
        }
        return {
            slidesPerView: slidesPerView,
            breakpoints: breakpoints
        };
    };
    BannerHeroImageFullPageWithVideo.prototype.muteTextFunction = function (muteText) {
        if (window.screen.width > 767) {
            muteText.innerHTML = "Click to mute/un-mute";
        }
        else {
            muteText.innerHTML = "Tap to mute/un-mute";
        }
    };
    BannerHeroImageFullPageWithVideo.prototype.toggleMute = function () {
        this.video.muted = !this.video.muted;
        if (this.video.muted) {
            this.muteIcon.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\">\n\t\t\t\t\t<path d=\"M0 0h24v24H0z\"/>\n\t\t\t\t\t<path d=\"M13.4 2.2 15 3v18l-1.6.8L5.667 16H1V8h4.666L13.4 2.2zM16 4a8 8 0 1 1 0 16v-2a6 6 0 1 0 0-12zm-3 1L7 9.5v5l6 4.5V5zm3 2a5 5 0 0 1 0 10v-2a3 3 0 0 0 0-6zM5 10H3v4h2v-4z\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\n\t\t\t\t</g>\n\t\t\t</svg>";
        }
        else {
            this.muteIcon.innerHTML = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t<defs>\n\t\t\t\t\t<linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"100%\" id=\"a\">\n\t\t\t\t\t\t<stop stop-color=\"#FFF\" offset=\"0%\"/>\n\t\t\t\t\t\t<stop stop-color=\"#FFF\" offset=\"100%\"/>\n\t\t\t\t\t</linearGradient>\n\t\t\t\t</defs>\n\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\">\n\t\t\t\t\t<path d=\"M0 0h24v24H0z\"/>\n\t\t\t\t\t<path d=\"M13.4 2.2 15 3v18l-1.6.8L5.667 16H1V8h4.666L13.4 2.2zM13 5 7 9.5v5l6 4.5V5zm8.667 4L23 10.333 21.333 12 23 13.667 21.667 15 20 13.333 18.333 15 17 13.667 18.667 12 17 10.333 18.333 9 20 10.667 21.667 9zM5 10H3v4h2v-4z\" fill=\"url(#a)\" fill-rule=\"nonzero\"/>\n\t\t\t\t</g>\n\t\t\t</svg>";
        }
    };
    BannerHeroImageFullPageWithVideo.prototype.detectHasVideo = function () {
        var buttonMuteContainer = this.element.querySelector('.banner-hero-image-full-page-with-video__mute');
        var bigSlider = this.element.querySelector('.banner-hero-image-full-page-with-video__banner--swiper');
        var activeSlide = bigSlider.querySelector('.swiper-slide-active');
        buttonMuteContainer.classList.remove('active');
        if (activeSlide.querySelector('video')) {
            console.log(activeSlide.querySelector('video'));
            buttonMuteContainer.classList.add('active');
        }
    };
    BannerHeroImageFullPageWithVideo.prototype.detectBizConnect = function () {
        if (this.element.querySelector('.bizconnect__description')) {
        }
        else {
            var bizConnectContainer = this.element.querySelector('.banner-hero-image-full-page-with-video__bizconnect');
            bizConnectContainer.classList.add('nobackground');
        }
    };
    BannerHeroImageFullPageWithVideo.prototype.playActiveSlideVideo = function () {
        var activeSlide = this.bigSliderContainer.querySelector('.swiper-slide-active');
        if (activeSlide.querySelector('video')) {
            var video = activeSlide.querySelector('video');
            video.play();
        }
    };
    return BannerHeroImageFullPageWithVideo;
}(Base));
export { BannerHeroImageFullPageWithVideo };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full-page-with-video/banner-hero-image-full-page-with-video.component.ts
// module id = 755
// module chunks = 0